import { jsx as _jsx } from "react/jsx-runtime";
import GlobalSearchResultItem from './GlobalSearchResultItem';
import GlobalSearchCard from './GlobalSearchCard';
import { Box, useTheme } from '@mui/material';
import { RecordCircle } from 'iconsax-react';
const GlobalSearchResult = ({ heading, items, searchTerm, onItemClick }) => {
    const theme = useTheme();
    return (_jsx(GlobalSearchCard, { heading: heading, accordion: true, children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, children: (items || []).map((item) => (_jsx(GlobalSearchResultItem, { title: item.title, searchTerm: 'searchTerm' in item ? item.searchTerm : searchTerm, onClick: () => {
                    if (onItemClick && item.entityType && item.id) {
                        onItemClick(item.entityType, String(item.id));
                    }
                }, meta: item.meta.map((metaItem) => metaItem.text
                    ? {
                        ...metaItem,
                        icon: (_jsx(RecordCircle, { variant: 'Bulk', style: { width: 12, height: 12, flexShrink: 0 }, color: theme.palette.text.tertiary }))
                    }
                    : {
                        ...metaItem,
                        icon: (_jsx(RecordCircle, { variant: 'Bulk', style: { width: 12, height: 12, flexShrink: 0 }, color: theme.palette.text.tertiary }))
                    }) }, item.id))) }) }));
};
export default GlobalSearchResult;
